import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
//This hook is used in login and register pages to refetch error messages when the user changes his language in the LanguageSwitcher.
//This happens because AuthZodValidation.jsx depends on a i18n, t object for sending validation messages in a translated language.
//It functions like a useForm wrapper that has handling for language switching
export const useLanguageAwareForm = (options) => {
  const { i18n } = useTranslation();
  const methods = useForm(options);
  const { trigger, formState } = methods;
  const { errors } = formState;

  const prevLanguageRef = useRef(i18n.language);
  const prevErrorsRef = useRef(errors);

  useEffect(() => {
    // Only re-validate fields with errors if language changed AND if we have errors
    if (prevLanguageRef.current !== i18n.language) {
      const fieldsWithErrors = Object.keys(errors || {});
      const prevFieldsWithErrors = Object.keys(prevErrorsRef.current || {});
      const allFieldsToRevalidate = [
        ...new Set([...fieldsWithErrors, ...prevFieldsWithErrors]),
      ];

      if (allFieldsToRevalidate.length > 0) {
        trigger(allFieldsToRevalidate);
      }
      prevErrorsRef.current = errors;
    }
    prevLanguageRef.current = i18n.language;
  }, [ errors, i18n.language, trigger]);

  return methods;
};
